export const COLUMN_PADDING = 20;
export const MIN_WIDTH = 75;
export const COLLAPSE_WIDTH = 500;
